import React, { useState, useRef, useEffect } from "react";
import { Button, Row, Col, Container } from "react-bootstrap";
import UserDetails from "./UserDetails";
import NavSearch from "./NavSearch/NavSearch";
import "./PageHomeMember.css";
import img1 from "../image/img1.png";
import img2 from "../image/img2.png";
import img3 from "../image/img3.png";
import ServiceAdmin from "../PageHomeAdmin/Services/ServiceAdmin";
const PageHomeMember = () => {
  const [speciality, setspeciality] = useState([]);
  useEffect(() => {
    GetSpecailite();
  }, []);
  const GetSpecailite = () => {
    ServiceAdmin.getSpecailite().then((res) => {
      setspeciality(res.data);
    });
  };

  return (
    <>
      <NavSearch />
      <div id="PagehomeMember">
        <Container>
          <Row className="justify-content-md-center">
            <Col lg={5} sm={12}>
              <h2
                style={{ color: "darkcyan", marginTop: "40px", padding: "0px" }}
              >
                Prenez Rendez vous avec vos professionnels de santé
              </h2>
              <div className="mfeature-body" style={{ fontSize: "large" }}>
                En cabinet ou à domicile, consultez votre docteur, médecin
                généraliste, spécialiste (dentiste, dermatologue, gynécologue,
                cardiologue, pédiatre, ophtalmologue...) ou professionnel
                paramédical (kinésithérapeute, orthophoniste, orthoptiste,
                ostéopathe, diététicien, podologue...).
              </div>
              <button
                type="button"
                className="btn btn-primary btn-lg"
                style={{ backgroundColor: "#756de7", marginTop: "10px" }}
              >
                Prenez Rendez vous
              </button>
            </Col>
            <Col lg={5} sm={12}>
              <img src={img1} alt="avatar" width="100%%" />
            </Col>
          </Row>
          <hr />
          <Row className="justify-content-md-center">
            <Col lg={5} sm={12}>
              <img src={img2} alt="avatar" width="83%" />
            </Col>
            <Col lg={5} sm={12}>
              <h2
                style={{ color: "darkcyan", marginTop: "50px", padding: "0px" }}
              >
                Votre consultation à domicile
              </h2>
              <div className="mfeature-body" style={{ fontSize: "large" }}>
                Besoin d'un diagnostic rapidement ? Sans vous déplacer ? Nos
                praticiens sont disponibles tout de suite pour une consultation
                chez vous.
              </div>
              <button
                type="button"
                className="btn btn-primary btn-lg"
                style={{ backgroundColor: "#756de7", marginTop: "10px" }}
              >
                Prenez Rendez vous
              </button>
            </Col>
          </Row>
          <hr />
          <Row className="justify-content-md-center">
            <Col lg={5} sm={12}>
              <h2
                style={{ color: "darkcyan", marginTop: "40px", padding: "0px" }}
              >
                Vos documents de santé toujours avec vous
              </h2>
              <div className="mfeature-body" style={{ fontSize: "large" }}>
                Conservez vos ordonnances,résultats d'examen, certificats dans
                un environnement sécurisé.
                <br />
                Partagez-les en direct avec vos praticiens avant,pendant ou
                aprés vos rendez vous médicaux.
              </div>
              <button
                type="button"
                className="btn btn-primary btn-lg"
                style={{ backgroundColor: "#756de7", marginTop: "10px" }}
              >
                Créer Votre Dossier
              </button>
            </Col>
            <Col lg={5} sm={12}>
              <img src={img3} alt="avatar" width="100%" />
            </Col>
          </Row>
        </Container>

        <footer id="footer">
          <div className="footer-top">
            <div className="container">
              <div className="row">
                <div className="col-lg-9 col-md-6 footer-links">
                  <h4>Trouver votre spécialiste</h4>
                  <div className="row">
                    {speciality.map((item, i) => {
                      return (
                        <div className="col-lg-3 col-md-6">
                          <ul>
                            <li
                              key="1"
                              style={{ padding: "0px", color: "#789d35" }}
                            >
                              <a href="#">{item.designation}</a>
                            </li>
                          </ul>
                        </div>
                      );
                    })}
                  </div>
                  {/* <ul>
                    <li>
                      <a href="#">Médecin géneraliste</a>
                    </li>
                    <li>
                      <a href="#">Chirugien dentiste</a>
                    </li>
                    <li>
                      <a href="#">Pédiatre</a>
                    </li>
                    <li>
                      <a href="#">gynécologue médical et obstétrique</a>
                    </li>
                    <li>
                      <a href="#">Ophtalmologue</a>
                    </li>
                    <li>
                      <a href="#">dermatologue et vénérologue</a>
                    </li>
                  </ul> */}
                </div>

                <div className="col-lg-3 col-md-6 footer-links">
                  <h4>A propos de DOCLIC</h4>
                  <ul>
                    <li key="1">
                      <a href="#">Vous étes professionnel de santé?</a>
                    </li>
                    <li key="2">
                      <a href="#">Qui sommes nous?</a>
                    </li>
                    <li key="3">
                      <a href="#">Nous contacter</a>
                    </li>
                    <li key="4">
                      <a href="#">En savoir plus sur la téléconsultation</a>
                    </li>
                    <li key="5">
                      <a href="#">FAQ</a>
                    </li>
                    <li key="6">
                      <a href="#">Presse</a>
                    </li>
                  </ul>
                  <h4>Nos Réseauxr</h4>
                  <ul>
                    <li key="1">
                      <a href="#">
                        <i className="fab fa-facebook"></i> Facebook
                      </a>
                    </li>
                    <li key="2">
                      <a href="#">
                        <i className="fab fa-youtube"></i> Youtube
                      </a>
                    </li>
                    <li key="3">
                      <a href="#">
                        <i className="fab fa-linkedin"></i> Linkedin
                      </a>
                    </li>
                  </ul>
                </div>

                {/* <div className="col-lg-4 col-md-6 footer-links">
                  <h4>Nos Réseauxr</h4>
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fab fa-facebook"></i> Facebook
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-youtube"></i> Youtube
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fab fa-linkedin"></i> Linkedin
                      </a>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>

          <div className="container">
            <div className="copyright">
              &copy; Copyright
              <strong>
                <span>
                  <a href="http://taleve.net"> Taleve</a>
                </span>
              </strong>
              . All Rights Reserved
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default PageHomeMember;
